import { LowerCasePipe } from '@angular/common';
import { Component, input, linkedSignal, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonDirective } from 'primeng/button';
import { FloatLabel } from 'primeng/floatlabel';
import { IconField } from 'primeng/iconfield';
import { InputIcon } from 'primeng/inputicon';
import { InputText } from 'primeng/inputtext';
import { Select } from 'primeng/select';

export interface TriggerFilterState {
    searchString: string;
    selectedTriggerTypes: string[];
    selectedActionTypes: string[];
    filterEnabled: string;
}

@Component({
    selector: 'trigger-filters',
    templateUrl: './triggerfilters.html',
    imports: [FormsModule, TranslatePipe, LowerCasePipe, ButtonDirective, FloatLabel, IconField, InputIcon, InputText, Select]
})
export class TriggerFiltersComponent {
    triggerTypeOptions = input<{ label: string; value: string }[]>([]);
    actionTypeOptions = input<{ label: string; value: string }[]>([]);
    enabledFilterOptions = input<{ label: string; value: string }[]>([]);
    shownTriggers = input<number>(0);

    searchStringInput = input<string>('', { alias: 'searchString' });
    selectedTriggerTypesInput = input<string[]>([], { alias: 'selectedTriggerTypes' });
    selectedActionTypesInput = input<string[]>([], { alias: 'selectedActionTypes' });
    filterEnabledInput = input<string>('ENABLED', { alias: 'filterEnabled' });

    searchString = linkedSignal(() => this.searchStringInput());
    selectedTriggerTypes = linkedSignal(() => this.selectedTriggerTypesInput());
    selectedActionTypes = linkedSignal(() => this.selectedActionTypesInput());
    filterEnabled = linkedSignal(() => this.filterEnabledInput());

    filtersChanged = output<TriggerFilterState>();
    newTriggerClicked = output<void>();

    emit(): void {
        this.filtersChanged.emit({
            searchString: this.searchString(),
            selectedTriggerTypes: this.selectedTriggerTypes(),
            selectedActionTypes: this.selectedActionTypes(),
            filterEnabled: this.filterEnabled()
        });
    }
}
